import { turfLineString } from '../utils';
import turfBbox from '@turf/bbox';

export const DEFAULT_BOUNDS = [
  [-5.6854854, 38.3286307],
  [36.8251381, 55.5815245]
];

export const DEFAULT_BBOX = turfBbox(turfLineString(DEFAULT_BOUNDS));
